import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors, withJsonpSupport } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { authInterceptor } from './auth-interceptor-interceptor';
import { environment } from '../environments/environment';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes), 
    provideNzI18n(en_US), 
    importProvidersFrom(FormsModule), 
    importProvidersFrom(ReactiveFormsModule),
    provideAnimationsAsync(), 
    provideHttpClient(withInterceptors([authInterceptor]), withJsonpSupport()), 
    provideServiceWorker('ngsw-worker.js', {
            enabled: environment.serviceWorker,
            registrationStrategy: 'registerImmediately'
    })
  ]
};
